
<template>
  <!--封禁管理-->
  <div>
    <x-tabula
      apiOrigin="PHP"
      ref="table"
      :dataSource="dataSource"
      rowKey="chat_forbidden_id"
      :rowOptLen="4"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :rowSelection="false"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
    >
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'ban',
  props: {
    tabType: {
      type: String,
      default: () => '1'
    }
  },
  data () {
    return {
      searchList: [
        { props: ['keywords'], placeholder: '昵称', options: [], inputType: 'input' },
        { props: ['chat_category_id'], placeholder: '禁言原因', options: [], inputType: 'select' },
        { props: ['create_date'], placeholder: ['截止时间', '截止时间'], options: [], inputType: 'datePick' }
      ],
      searchParams: {
        keywords: undefined,
        chat_category_id: undefined,
        create_date: undefined
      },
      tableOptList: [],
      rowOptList: [
        {
          text: '撤销',
          handle: record => this.cancelBan(record),
          rowOptDisHandle: row => row.can_delete === 0,
          permi: ['neighbour:banManage:cancel']
        }
      ],
      columns: [],
      columnsSource: [
        { title: '昵称', dataIndex: 'nick_name', align: 'left', width: '' },
        { title: '禁言原因', dataIndex: 'chat_category_desc', align: 'left', width: '' },
        { title: '禁言范围', dataIndex: 'scope', align: 'left', width: '' },
        { title: '封禁时间', dataIndex: 'create_time', align: 'left', width: '' },
        { title: '截止时间', dataIndex: 'end_time', align: 'left', width: '' },
        { title: '操作', dataIndex: 'action', align: 'left', width: '', scopedSlots: {customRender: 'action'} }
      ],
      dataSource: [],
      listApi: {
        url: `/chat/forbidden/list/${this.tabType}`,
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '新增封禁'
      },
      deleteParam: {
        url: '',
        param: {pk_key: '', pk_val: ''},
        title: '',
        key: ''
      }
    };
  },
  created () {
    this.columns = this.columnsSource.map(el => ({...el}));
    this.tabChange(this.tabType);
    this.getSelect();
  },
  methods: {
    /* 获取下拉 */
    getSelect () {
      this._get({
        url: '/chat/forbidden/selectlist',
        params: { type: this.tabType }
      }).then(({data}) => {
        this.searchList[1].options = data.category;
      });
    },
    /** 切换页签 */
    tabChange (e) {
      // type：1.禁言 2.禁止发布动态 3.禁止发表评论
      if (e === '1') {
        this.columns = this.columnsSource.map(el => ({...el}));
        this.columns[1].title = '禁言原因';
      } else if (e === '2') {
        this.columns.splice(2, 1);
        this.columns[1].title = '禁止发布动态原因';
      } else {
        this.columns.splice(2, 1);
        this.columns[1].title = '禁止评论回复原因';
      }
    },
    /** 撤销封禁 */
    cancelBan (record) {
      this.$confirm({
        title: '确定要撤销封禁？',
        centered: true,
        onOk: () => {
          this._delete({
            url: '/chat/forbidden',
            params: {
              pk_key: 'chat_forbidden_id',
              pk_val: record.chat_forbidden_id
            }
          }).then(({data}) => {
            this.$message.success('撤销成功');
            this.$refs.table.getTableList();
          });
        }
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>
